import { ReactNode } from "react";

import { ContentCard } from "@narmi/design_system";

import styles from "./Section.module.scss";

interface SectionProps {
  title: string;
  children: ReactNode;
}

const Section = ({ title, children }: SectionProps) => (
  <div className={styles.section}>
    <div className={styles.sectionTitle}>{title}</div>
    <ContentCard kind="bordered">{children}</ContentCard>
  </div>
);

export default Section;
